import * as React from 'react';

import { FeatureAppEnvironment } from '@feature-hub/core';
import type { MocksServerConfig } from '@volkswagen-onehub/fetch-json';

import { useSafeContext } from '../utils/use-safe-context';

import { VisualizerFeatureAppDependencies } from '../hooks/use-feature-services';

import { RequireDefined } from '../utils/require-defined';

export interface CommonFeatureAppConfig {
	readonly mockIds: string | undefined;
	readonly mocksServerConfig: MocksServerConfig | undefined;
}

export const defaultCommonFeatureAppConfig: CommonFeatureAppConfig = {
	mockIds: undefined,
	mocksServerConfig: undefined
};

type VisualizerFeatureAppEnvironment = RequireDefined<
	FeatureAppEnvironment<VisualizerFeatureAppDependencies, CommonFeatureAppConfig>,
	'config'
>;

export const FeatureAppEnvironmentContext = React.createContext<VisualizerFeatureAppEnvironment | undefined>(undefined);

export function useFeatureAppEnvironment(): VisualizerFeatureAppEnvironment {
	return useSafeContext(FeatureAppEnvironmentContext, 'featureAppEnvironment');
}
